import { fecha, type Idioma, type useTraduccion } from '@tallerya/i18n';
import type { FichaCliente } from './datos';

/**
 * La línea de datos bajo el título de la edición (#160): «CLI-00033 · Creado el
 * 12 mar 2026 · Última modificación: hoy por Vladimir Orellana». Es la misma de
 * Productos (`productos-servicios/encabezado.ts`). Son datos que se leen siempre, así que
 * van en `descripcion` y no tras el ⓘ (#120).
 *
 * Sin autor —la última firma es de la plataforma o de alguien ya eliminado—, la
 * línea dice solo la fecha.
 */
export function encabezado(
  ficha: FichaCliente,
  idioma: Idioma,
  t: ReturnType<typeof useTraduccion>['t'],
): string {
  const cuando = (valor: string) =>
    new Date(valor).toDateString() === new Date().toDateString()
      ? t('admin.clientes.formulario.hoy')
      : fecha(valor, idioma);

  const modificado = ficha.updatedBy
    ? t('admin.clientes.formulario.modificadoPor', { fecha: cuando(ficha.updatedAt), autor: ficha.updatedBy })
    : t('admin.clientes.formulario.modificado', { fecha: cuando(ficha.updatedAt) });

  return [ficha.code, t('admin.clientes.formulario.creado', { fecha: fecha(ficha.createdAt, idioma) }), modificado]
    .filter(Boolean)
    .join(' · ');
}
